<div class="alert-modal_header">
  <div class="alert-modal_title">
    @if (alertTitleTranslate) {
      {{alertTitle | l10n:alertMessageTranslationParams}}
    } @else {
      {{alertTitle}}
    }
  </div>
  <svg class="alert-modal_close-icon" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
<div class="alert-modal_body">
  @if (alertMessageTranslate) {
    {{alertMessage | l10n:alertMessageTranslationParams}}
  } @else {
    {{alertMessage}}
  }
</div>

<div class="alert-modal_footer">
  <button type="submit" class="alert-modal_button" (click)="close()">
    {{alertButtonText | l10n}}
  </button>
</div>
